export const PARTS_DELIMITER = '_';
export const compareFileName = ({
    fileName1,
    fileName2,
    filterByDevice = false,
}) => {
    let fn1 = fileName1;
    let fn2 = fileName2;
    if (fn1 === fn2) {
        return true;
    }

    if (!fn1 || !fn2) {
        return false;
    }
    const fileParts1 = fn1?.split?.(PARTS_DELIMITER) ?? [];
    const fileParts2 = fn2?.split?.(PARTS_DELIMITER) ?? [];
    if (!filterByDevice) {
        if (fileParts1.length > 2) {
            fileParts1.splice(1, 1);
        }
        if (fileParts2.length > 2) {
            fileParts2.splice(1, 1);
        }
        fn1 = fileParts1.join(PARTS_DELIMITER);
        fn2 = fileParts2.join(PARTS_DELIMITER);
    }

    return fn1 === fn2;

};


export const getDeviceIdFromBackupFile = (fileName, isIos = false) => {
    if (!fileName) {
        return null;
    }
    const parts = fileName.split(PARTS_DELIMITER);
    console.log('getDeviceIdFromBackupFile', {
        fileName,
        parts,
    });
    if (isIos) {
        // iOS backup file name format: "backup_1234567890_1234567890.json"
        if (parts.length < 3) {
            return null;
        }
        return parts[2];
    }
    if (parts.length < 3) {
        return null;
    }
    return parts[1];
};
